import React from 'react';
import { motion } from 'framer-motion';
export function FinalComparison() {
  const sinItems = [{
    icon: '⏰',
    text: '3-5 hs/semana planificando desde cero'
  }, {
    icon: '😓',
    text: 'Siempre los mismos drills y ejercicios'
  }, {
    icon: '💸',
    text: 'Alumnos que abandonan sin saber por qué'
  }, {
    icon: '📋',
    text: 'Sin progresión clara de nivel a nivel'
  }, {
    icon: '😨',
    text: 'Grupo heterogéneo = caos en la clase'
  }, {
    icon: '👥',
    text: 'Sin variedad = alumnos aburridos y estancados'
  }, {
    icon: '📱',
    text: 'Sin sistema de comunicación con alumnos'
  }, {
    icon: '💼',
    text: 'Sin identidad profesional visible'
  }, {
    icon: '🎾',
    text: 'Sin táctica = alumnos que no entienden su propio juego'
  }, {
    icon: '🧠',
    text: 'Sin mentalidad = alumnos que se rinden bajo presión'
  }, {
    icon: '💰',
    text: 'Cobrando lo mismo que hace 3 años'
  }, {
    icon: '📊',
    text: 'Sin métricas ni evidencia de tu propio trabajo'
  }];
  const conItems = [{
    icon: '⏰',
    text: '10 min/semana. El resto es enseñar.'
  }, {
    icon: '😓',
    text: '60+ recursos y clases distintas listas'
  }, {
    icon: '💸',
    text: 'Progresión visible = retención real'
  }, {
    icon: '📋',
    text: '6 tomos con planificación anual completa'
  }, {
    icon: '😨',
    text: 'Recursos para gestionar cualquier nivel en la misma clase'
  }, {
    icon: '👥',
    text: '100 drills para meses de variedad en cancha'
  }, {
    icon: '📱',
    text: 'Guía completa con mensajes listos para usar'
  }, {
    icon: '💼',
    text: 'Sistema que justifica cobrar más'
  }, {
    icon: '🎾',
    text: '8 patrones tácticos con diagrama para enseñar tenis inteligente'
  }, {
    icon: '🧠',
    text: 'Rutinas mentales y herramientas de visualización para competidores reales'
  }, {
    icon: '💰',
    text: 'Estructura de precios y paquetes para cobrar lo que valés'
  }, {
    icon: '📊',
    text: 'Fichas de evaluación que demuestran el progreso de cada alumno'
  }];
  return <section className="py-12 md:py-20 bg-cream" data-id="element-92">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="text-center mb-10 md:mb-16" data-id="element-94">
          <h2 className="text-2xl md:text-4xl font-display text-navy-900 mb-2" data-id="element-95">
            MEGAPACK TENIS RESUELTO™
          </h2>
          <p className="text-base md:text-xl text-gray-600 mb-6 md:mb-8" data-id="element-96">
            El próximo lunes podés volver a improvisar la clase.
            <br data-id="element-97" />
            <span className="font-bold text-terracotta" data-id="element-98">
              O podés entrar al club o academia con todo resuelto desde hoy.
            </span>
          </p>
          <h3 className="text-2xl md:text-3xl font-display text-navy-900 uppercase" data-id="element-99">
            ¿Cuánto cuesta NO tenerlo?
          </h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-8" data-id="element-100">
          {/* SIN */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-5 md:p-8 border border-red-100 shadow-sm" data-id="element-101">
            <div className="text-center mb-4 md:mb-6" data-id="element-102">
              <span className="inline-block bg-red-100 text-red-700 font-bold px-4 md:px-6 py-1.5 md:py-2 rounded-full uppercase tracking-wide text-xs md:text-base" data-id="element-103">
                SIN SISTEMA
              </span>
            </div>
            <ul className="space-y-2.5 md:space-y-4" data-id="element-104">
              {sinItems.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm md:text-base text-gray-600" data-id="element-105">
                  <span className="text-lg md:text-xl flex-shrink-0" data-id="element-106">
                    {item.icon}
                  </span>
                  <span className="pt-0.5" data-id="element-107">{item.text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* CON */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900 rounded-3xl p-5 md:p-8 border-2 border-optic shadow-xl" data-id="element-108">
            <div className="text-center mb-4 md:mb-6" data-id="element-109">
              <span className="inline-block bg-optic text-navy-900 font-bold px-4 md:px-6 py-1.5 md:py-2 rounded-full uppercase tracking-wide text-xs md:text-base" data-id="element-110">
                CON MEGAPACK
              </span>
            </div>
            <ul className="space-y-2.5 md:space-y-4" data-id="element-111">
              {conItems.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm md:text-base text-white" data-id="element-112">
                  <span className="text-lg md:text-xl flex-shrink-0" data-id="element-113">
                    {item.icon}
                  </span>
                  <span className="pt-0.5 font-medium" data-id="element-114">{item.text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="mt-10 md:mt-16 text-center" data-id="element-115">
          <h2 className="text-2xl md:text-4xl font-display text-terracotta uppercase" data-id="element-116">
            No dejes pasar esta oportunidad
          </h2>
        </div>
      </div>
    </section>;
}